export default "__VITE_ASSET__BAcpDnTc__$_?=raw__"